import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 127.551 127.551" {...props}><path fill="none" stroke="#B3B3B3" strokeLinecap="round" d="M63.775 2c34.117 0 61.775 27.658 61.775 61.775S97.892 125.55 63.775 125.55 2 97.892 2 63.775c0 0 0 0 0 0C2 29.658 29.658 2 63.775 2z" /><circle fill="#B3B3B3" cx="63.501" cy="44.07" r="4.5" /><path fill="none" stroke="#B3B3B3" d="M63.5 57.051v30" /></svg>);